import React from "react";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    title: "SICAK SU İLE HALI YIKAMA",
    image: "/images/blog/sicak-su.png",
    excerpt:
      "Halı yıkama sektöründe sıcak su kullanımı genellikle yapılmaz, ancak sıcak suyla yıkamanın sağladığı hijyen etkisi büyüktür.",
    slug: "sicak-su-ile-hali-yikama",
  },
  {
    title: "PROFESYONEL HALI YIKAMA",
    image: "/images/blog/profesyonel.png",
    excerpt:
      "Evde yapılan temizlikle kıyaslanamayacak düzeyde derin hijyen sağlayan profesyonel yıkama yöntemleri hakkında bilgi alın.",
    slug: "profesyonel-hali-yikama",
  },
  {
    title: "HANGİ HALI YIKAMACI",
    image: "/images/blog/yikamaci.png",
    excerpt:
      "Piyasada çok fazla halı yıkamacı var. Kaliteli olanı nasıl seçersiniz? İşte dikkat edilmesi gerekenler.",
    slug: "hangi-hali-yikamaci",
  },
  {
    title: "KUYU SUYU İLE HALI YIKAMA",
    image: "/images/blog/kuyu.png",
    excerpt:
      "Bazı halı yıkama firmaları maliyeti düşürmek için kuyu suyu kullanıyor. Bu durumun sağlığa ve halınıza etkilerini öğrenin.",
    slug: "kuyu-suyu-ile-hali-yikama",
  },
];

const BlogList = () => {
  return (
    <section className="bg-[#f7f7d4] py-12 px-4">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex justify-center mb-10">
          <img
            src="/images/headings/bloglogo.png"
            alt="Blog Yazilari"
            className="h-20 sm:h-28 md:h-40"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {blogPosts.map((post, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-200 shadow-md p-4"
            >
              <h3 className="text-sm font-bold text-gray-800 mb-2">
                {post.title}
              </h3>
              <img
                src={post.image}
                alt={post.title}
                width={1111}
                height={225}
                className="w-full h-48 object-cover rounded mb-3"
              />
              <p className="text-[14px] text-gray-700 leading-relaxed">
                {post.excerpt}
              </p>
              <div className="mt-4">
                <Link
                  to={`/blog/${post.slug}`}
                  className="inline-block bg-[#dce7d0] hover:bg-[#bdd3a6] text-gray-800 px-4 py-2 rounded-full text-sm font-medium"
                >
                  Yazının Devamı
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-12">
          <Link
            to="/blog"
            className="bg-[#6f8d5f] hover:bg-[#4c693e] text-white px-6 py-3 rounded-full text-lg font-semibold shadow-md transition-all duration-300"
          >
            Diğer Blog Yazılarımız
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogList;
